export default __webpack_public_path__ + "static/media/TriviaSansBook-Italic.13138206.otf";